import { Content, Header, Page } from '@backstage/core-components';
import { Route, Routes } from 'react-router-dom';
import { PendingChecklistsPage } from './components/PendingChecklistsPage';
import { ChecklistEditorPage } from './components/ChecklistEditorPage';
import { CHECKLIST_APPROVAL_STYLES } from './styles';

export function ChecklistApprovalPage() {
  return (
    <Page themeId="tool">
      <style>{CHECKLIST_APPROVAL_STYLES}</style>

      <Header title="Compliance Audit Checklist Approval" />

      <Content>
        <div className="checklist-page-container">
          <Routes>
            <Route index element={<PendingChecklistsPage />} />

            <Route path=":checklistId" element={<ChecklistEditorPage />} />
          </Routes>
        </div>
      </Content>
    </Page>
  );
}
